<template>
    <Table
        class="hidden lg:block"
        :disabled="disabled"
    >
        <template #thead>
            <tr class="hidden pad:table-row">
                <td class="w-4" />
                <td class="w-32">
                    發卡機構
                </td>
                <td class="w-[15rem]">
                    卡號
                </td>
                <td class="min-w-[32.5rem] pr-0">
                    <div
                        class="grid gap-2"
                        :class="[disabled?'grid-cols-10':'grid-cols-8']"
                    >
                        <div class="col-span-3">
                            保單號碼
                        </div>
                        <div class="col-span-3">
                            主約險種
                        </div>
                        <div class="col-span-2">
                            被保險人
                        </div>
                        <div
                            v-if="disabled"
                            class="col-span-2"
                        />
                    </div>
                </td>
                <!-- <td
                    v-if="disabled"
                    class="w-[5.25rem]"
                /> -->
            </tr>
        </template>
        <template #tbody>
            <tr
                v-for="(row, index) in data"
                :key="index"
                @click="!disabled?checkRow(row?.cardNo):''"
            >
                <td class="text-center pl-4 align-top pt-4">
                    <Radio
                        v-model:checkedValue="policyRadio"
                        :value="row?.cardNo"
                        name="policy1"
                        :disabled="disabled"
                    />
                </td>
                <td class="align-top">
                    {{ row.cardBankName }}
                </td>
                <td class="align-top">
                    {{ row.label }}
                </td>
                <td class="divide-dashed divide-y space-y-2.5 pr-0 align-top">
                    <div
                        v-for="(policy, i) in row.dataList"
                        :key="i"
                        class="grid space-top gap-2"
                        :class="[disabled?'grid-cols-10':'grid-cols-8']"
                    >
                        <div class="col-span-3">
                            {{ policy.fullPolicyNo }}
                        </div>
                        <div class="col-span-3">
                            {{ policy.itemName }}
                        </div>
                        <div class="col-span-2">
                            {{ policy.name }}
                        </div>
                        <div
                            v-if="disabled"
                            class="col-span-2"
                        >
                            <div class="bg-gray-400 text-sm text-white p-1.5">
                                {{ policy.memo }}
                            </div>
                        </div>
                    </div>
                </td>
                <!-- <td
                    v-if="disabled"
                    class="px-0 py-2.5 align-top"
                >
                    <div class="bg-gray-400 text-sm text-white p-1.5">
                        {{ policy.memo }}
                    </div>
                </td> -->
            </tr>
        </template>
    </Table>
</template>

<script>
import { toRef } from 'vue';
import Table from '@/components/table/Table.vue';
import Radio from '@/components/radios/Radio.vue';

export default {
    components: {
        Table,
        Radio,
    },
    props: {
        checkedRadio: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update:checkedRadio'],
    setup(props, { emit }) {
        const policyRadio = toRef(props, 'checkedRadio');
        const checkRow = (itemNo) => {
            if (props.disabled) return;
            emit('update:checkedRadio', itemNo);
        };
        return {
            checkRow,
            policyRadio
        };
    }
};
</script>
<style scoped lang="scss">
.space-top:not(:first-child) {
    @apply pt-2.5;
}
</style>
